// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__RYORe","buttons":"PendingPaymentAlert_buttons__2dIid"};